import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AppContext";

const ProtectedRoute = ({ children }) => {
  const { auth } = useAuth();
  console.log(auth);
  
  // If user is not authenticated, redirect to login page
  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
